export const isValidUrlRegex = (url: string) => {
  const pattern = new RegExp(
    '^(https?:\\/\\/)' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name and extension
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?' + // port
      '(\\/[-a-z\\d%_.~+]*)*' + // path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$',
    'i', // fragment locator
  );
  return !!pattern.test(url);
};

export const isValidLinkedinCompanyUrl = (url: string) => {
  const regex = /^(https?:\/\/)?(www\.)?linkedin\.com\/company\/([a-zA-Z0-9-]*)\/?$/;
  return regex.test(url);
};
